import React from 'react';
import { doorForAddress } from '../../lib/signInDoors';
import RideLogoFloat from '../brand/RideLogoFloat';

// The full-screen "Loading..." shown while the session is checked. On The Ride's door it shows The Ride's moving logo on the
// icon's dark field (locked 2026-10-25); every other door keeps the plain text it always had.
export default function AppLoadingScreen() {
    const door = doorForAddress(window.location);
    if (door.slug === 'the-ride-atl' && door.signInLogo) {
        return (
            <div className="ride-loading" role="status" aria-live="polite">
                <RideLogoFloat src={`${process.env.PUBLIC_URL || ''}/${door.signInLogo}`} alt={`${door.brand.brand_name} logo`} />
                <p className="ride-loading__text">Loading...</p>
            </div>
        );
    }
    return (
        <div className="flex items-center justify-center h-screen">
            <div className="text-2xl">Loading...</div>
        </div>
    );
}
